import { CommonInputProps } from '@healthnz-prm/fhir-engine-renderer/types'
import { FieldLabel } from '@/components/fhirEngineClinical/inputFieldset'
import { useAdditionalLabelProperties } from '@/components/fhirEngineClinical/utils/additionalProperties'

export function InputLabel({
  disabled,
  error,
  inputId,
  label,
  labelComponent,
  required,
  supportLink,
  supportModal
}: Partial<CommonInputProps<any>>) {
  const additionalProps = useAdditionalLabelProperties({
    label,
    labelComponent,
    supportLink,
    supportModal,
    required
  })

  return (
    <FieldLabel
      {...additionalProps}
      disabled={disabled}
      error={!!error}
      htmlFor={inputId}
    />
  )
}
